import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import Header from "@/components/Header";
import HeaderHero from "@/components/HeaderHero";
import Footer from "@/components/Footer";
import { Link } from 'wouter';

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
import './eventos-hover.css';
import { Sprout, Network, Users } from "lucide-react";
import { FadeIn, FadeInUp, FadeInLeft, FadeInRight, StaggerContainer, StaggerItem } from "@/components/AnimatedSection";
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';

export default function Home() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');
  
  const [emblaRef, emblaApi] = useEmblaCarousel({ 
    loop: true,
    align: 'start',
    slidesToScroll: 1
  });

  // Auto-play do carrossel
  useEffect(() => {
    if (!emblaApi) return;
    
    const interval = setInterval(() => {
      emblaApi.scrollNext();
    }, 3000);
    
    return () => clearInterval(interval);
  }, [emblaApi]);

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);


  
  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    console.log('Form submitted!');
    e.preventDefault();
    setFormStatus('loading');
    const formData = new FormData(e.currentTarget);
    const nome = formData.get('nome') as string;
    const email = formData.get('email') as string;
    const mensagem = formData.get('mensagem') as string;
    
    console.log('Enviando dados:', { nome, email, mensagem });
    
    try {
      const response = await fetch('https://formspree.io/f/mblznbne', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name: nome, email: email, message: mensagem }),
      });
      
      console.log('Response status:', response.status);
      const data = await response.json();
      console.log('Response data:', data);
      
      if (response.ok) {
        console.log('Sucesso! Atualizando estado...');
        setFormStatus('success');
        setFormMessage('Orçamento enviado com sucesso! Entraremos em contato em breve.');
        // Resetar o formulário
        const form = document.querySelector('form');
        if (form) form.reset();
        setTimeout(() => setFormStatus('idle'), 5000);
      } else {
        console.log('Erro na resposta:', data);
        setFormStatus('error');
        setFormMessage('Erro ao enviar o formulário. Tente novamente.');
        setTimeout(() => setFormStatus('idle'), 5000);
      }
    } catch (error) {
      console.error('Erro ao enviar:', error);
      setFormStatus('error');
      setFormMessage('Erro ao enviar o formulário. Tente novamente.');
      setTimeout(() => setFormStatus('idle'), 5000);
    }
  };

  const produtosLogos = [
    '5.png', '6.png', '7.png', '8.png', 
    '9.png', '10.png', '11.png', '12.png', 'logo-yara.png'
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        {/* Hero Section + Produtos = 100vh */}
        <div style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
          {/* Hero Section com Glasmorphism Card */}
          <section className="relative overflow-hidden flex-1 flex items-center justify-center" style={{
            backgroundImage: "url('/images/hero-lavoura.jpg')",
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}>
            <div className="absolute inset-0 bg-black/40" />
            
            <div className="hero-card-wrapper relative z-10 h-5/6 flex flex-col" style={{
              backgroundColor: 'rgba(242, 242, 242, 0.15)',
              backdropFilter: 'blur(10px)',
              borderRadius: '24px',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}>
              {/* Header dentro do card */}
              <HeaderHero />
              
              {/* Conteúdo - Container único centralizado em mobile */}
              <div className="flex-1 flex flex-col justify-center px-8 sm:px-12 pb-8 sm:pb-12 md:items-start items-center md:text-left text-center">
                <FadeInUp>
                  <h1 className="mb-6 w-full" style={{fontFamily: "'Suez One', serif", fontSize: 'clamp(2.5rem, 5vw, 5rem)', lineHeight: '110%', color: '#f2f2f2', maxWidth: '100%', overflow: 'visible', whiteSpace: 'normal'}}>
                    Raízes firmes,<br />negócios sólidos
                  </h1>
                </FadeInUp>
                <FadeInUp delay={0.2}>
                  <p className="mb-8 w-full" style={{fontFamily: "'Familjen Grotesk', sans-serif", fontSize: 'clamp(0.875rem, 1.5vw, 1.125rem)', lineHeight: '140%', color: '#ffffff', maxWidth: '100%'}}>
                    Há mais de 30 anos fornecendo fertilizantes de excelência para os produtores do Brasil.
                  </p>
                </FadeInUp>
                <FadeInUp delay={0.4}>
                  <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center sm:justify-start">
                    <Link href="/sobre-nos" onClick={scrollToTop}>
                      <Button size="lg" className="w-full sm:w-auto font-semibold uppercase" style={{backgroundColor: '#D3D655', color: '#003B4A'}}>
                        Conheça a Fercci
                      </Button>
                    </Link>
                    <Link href="/contato" onClick={scrollToTop}>
                      <Button 
                        size="lg" 
                        className="w-full sm:w-auto font-semibold uppercase transition-all duration-300" 
                        style={{
                          backgroundColor: 'transparent',
                          border: '2px solid #D3D655',
                          color: '#D3D655'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#D3D655';
                          e.currentTarget.style.color = '#003B4A';
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                          e.currentTarget.style.color = '#D3D655';
                        }}
                      >
                        Faça um orçamento
                      </Button>
                    </Link>
                  </div>
                </FadeInUp>
              </div>
            </div>
          </section>
        </div>

        {/* Carrossel de Produtos com Setas */}
        <section className="relative py-6 bg-background border-b border-border">
            <div className="container relative">
              <div className="relative flex items-center">
                <button 
                  onClick={scrollPrev}
                  className="absolute left-0 top-1/2 -translate-y-1/2 z-10 hover:opacity-70 transition-opacity"
                  aria-label="Anterior"
                  style={{color: '#003B4A'}}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                </button>
                
                <div className="embla overflow-hidden flex-1 mx-12" ref={emblaRef}>
                  <div className="embla__container flex gap-12 items-center px-8">
                    {produtosLogos.map((logo, index) => (
                      <div key={index} className="embla__slide flex-[0_0_33.333%] md:flex-[0_0_16.666%] w-32">
                        <img loading="lazy" 
                          src={`/images/produtos/${logo}`} 
                          alt={`Produto ${index + 1}`}
                          className="h-24 md:h-20 w-auto object-contain mx-auto"
                          onError={(e) => {
                            console.log(`Erro ao carregar: ${logo}`);
                            e.currentTarget.style.display = 'none';
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                <button 
                  onClick={scrollNext}
                  className="absolute right-0 top-1/2 -translate-y-1/2 z-10 hover:opacity-70 transition-opacity"
                  aria-label="Próximo"
                  style={{color: '#003B4A'}}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            </div>
          </section>

        {/* Escale seus resultados */}
        <section className="py-16 md:py-24 relative overflow-hidden" style={{backgroundColor: '#003B4A'}}>
          <div className="container relative z-10">
            <FadeInUp>
              <div className="max-w-3xl mx-auto text-center mb-16">
                <h2 className="text-4xl md:text-6xl mb-6 font-serif" style={{fontFamily: "'Suez One', serif", color: '#D3D655'}}>
                  Escale os seus resultados
                </h2>
                <p className="text-base md:text-lg" style={{lineHeight: "1.4", color: '#ffffff'}}>
                  Nossa missão é oferecer soluções completas, combinadas com serviços de alta qualidade, 
                  para que nossos clientes alcancem o máximo potencial produtivo de suas lavouras.
                </p>
              </div>
            </FadeInUp>

            {/* Círculos sobrepostos com animação dominó - ordem 4, 3, 2, 1 da esquerda para direita */}
            <div className="flex justify-center items-center mb-16">
              <div className="relative flex items-center" style={{height: '90px'}}>
                <FadeIn delay={0}>
                  <div className="relative z-40" style={{width: '80px', height: '80px', marginRight: '-20px'}}>
                    <img loading="lazy" 
                      src="/images/circulos/novo.4.png" 
                      alt="" 
                      style={{
                        width: '80px',
                        height: '80px',
                        objectFit: 'cover',
                        filter: 'contrast(1.1) brightness(1.05)'
                      }}
                    />
                  </div>
                </FadeIn>
                <FadeIn delay={0.4}>
                  <div className="relative z-30" style={{width: '80px', height: '80px', marginRight: '-20px'}}>
                    <img loading="lazy" 
                      src="/images/circulos/novo.3.webp" 
                      alt="" 
                      style={{
                        width: '80px',
                        height: '80px',
                        objectFit: 'cover',
                        filter: 'contrast(1.1) brightness(1.05)'
                      }}
                    />
                  </div>
                </FadeIn>
                <FadeIn delay={0.8}>
                  <div className="relative z-20" style={{width: '80px', height: '80px', marginRight: '-20px'}}>
                    <img loading="lazy" 
                      src="/images/circulos/novo.2.webp" 
                      alt="" 
                      style={{
                        width: '80px',
                        height: '80px',
                        objectFit: 'cover',
                        filter: 'contrast(1.1) brightness(1.05)'
                      }}
                    />
                  </div>
                </FadeIn>
                <FadeIn delay={1.2}>
                  <div className="relative z-10" style={{width: '80px', height: '80px'}}>
                    <img loading="lazy" 
                      src="/images/circulos/novo.1.png" 
                      alt="" 
                      style={{
                        width: '80px',
                        height: '80px',
                        objectFit: 'cover',
                        filter: 'contrast(1.1) brightness(1.05)'
                      }}
                    />
                  </div>
                </FadeIn>
              </div>
            </div>

            {/* Nossos Serviços */}
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-6xl mb-4 font-serif" style={{fontFamily: "'Suez One', serif", color: '#ffffff'}}>
                Nossos Serviços
              </h2>
              <p className="text-base md:text-lg" style={{lineHeight: "1.4", color: '#ffffff'}}>
                Tecnologia e tradição unidas para resultados superiores.
              </p>
            </div>

            {/* Cards de Serviços */}
            <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
              {/* Card 1 - Aurora - Curva superior direita */}
              <StaggerItem>
                <Card className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30  hover:shadow-2xl transition-all hover:scale-105 overflow-hidden" 
                      style={{
                        borderTopRightRadius: '80px',
                        borderTopLeftRadius: '8px',
                        borderBottomLeftRadius: '8px',
                        borderBottomRightRadius: '8px',
                        backgroundColor: 'rgba(211, 214, 85, 0.25)', border: '2px solid #D3D655'
                      }}>
                  <CardContent className="p-8 text-center flex flex-col h-full">
                    <div className="w-16 h-16 mx-auto mb-6 rounded-full flex items-center justify-center" 
                         style={{backgroundColor: '#D3D655'}}>
                      <Sprout className="w-8 h-8" style={{color: '#003B4A'}} />
                    </div>
                    <h3 className="text-2xl md:text-3xl font-semibold mb-3" style={{color: '#f2f2f2'}}>
                      Fertilizantes Premium
                    </h3>
                    <p className="mb-6 flex-grow" style={{color: '#f2f2f2'}}>
                      Produtos de alta qualidade para maximizar a produtividade da sua lavoura.
                    </p>
                    <Link href="/servicos" onClick={scrollToTop}>
                      <Button variant="link" className="font-semibold text-base" style={{color: '#f2f2f2'}}>
                        Saiba mais →
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              </StaggerItem>

              {/* Card 2 - Brisa - Sem curva acentuada */}
              <StaggerItem>
                <Card className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30  hover:shadow-2xl transition-all hover:scale-105 overflow-hidden rounded-lg" 
                      style={{
                        backgroundColor: 'rgba(159, 207, 202, 0.25)', border: '2px solid #9FCFCA'
                      }}>
                  <CardContent className="p-8 text-center flex flex-col h-full">
                    <div className="w-16 h-16 mx-auto mb-6 rounded-full flex items-center justify-center" 
                         style={{backgroundColor: '#9FCFCA'}}>
                      <Network className="w-8 h-8" style={{color: '#003B4A'}} />
                    </div>
                    <h3 className="text-2xl md:text-3xl font-semibold mb-3" style={{color: '#f2f2f2'}}>
                      Rede de Vantagens
                    </h3>
                    <p className="mb-6 flex-grow" style={{color: '#f2f2f2'}}>
                      Programa de fidelidade exclusivo com benefícios e recompensas.
                    </p>
                    <Link href="/programa-fidelidade" onClick={scrollToTop}>
                      <Button variant="link" className="font-semibold text-base" style={{color: '#f2f2f2'}}>
                        Saiba mais →
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              </StaggerItem>

              {/* Card 3 - Seiva - Curva superior esquerda */}
              <StaggerItem>
                <Card className="h-full w-full bg-clip-padding backdrop-filter backdrop-blur-md bg-opacity-30  hover:shadow-2xl transition-all hover:scale-105 overflow-hidden" 
                      style={{
                        borderTopRightRadius: '8px',
                        borderTopLeftRadius: '80px',
                        borderBottomLeftRadius: '8px',
                        borderBottomRightRadius: '8px',
                        backgroundColor: 'rgba(29, 134, 73, 0.25)', border: '2px solid #1D8649'
                      }}>
                  <CardContent className="p-8 text-center flex flex-col h-full">
                    <div className="w-16 h-16 mx-auto mb-6 rounded-full flex items-center justify-center" 
                         style={{backgroundColor: '#1D8649'}}>
                      <Users className="w-8 h-8" style={{color: '#003B4A'}} />
                    </div>
                    <h3 className="text-2xl md:text-3xl font-semibold mb-3" style={{color: '#f2f2f2'}}>
                      Consultoria Personalizada
                    </h3>
                    <p className="mb-6 flex-grow" style={{color: '#f2f2f2'}}>
                      Atendimento especializado para otimizar seus resultados.
                    </p>                    <Link href="/sobre-nos" onClick={scrollToTop}>
                      <Button variant="link" className="font-semibold text-base" style={{color: '#f2f2f2'}}>
                        Saiba mais →
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              </StaggerItem>
            </StaggerContainer>
          </div>
        </section>

        {/* Nossos Eventos */}
        <section className="relative py-16 md:py-24 bg-secondary text-secondary-foreground overflow-hidden">
          {/* Textura de fundo */}
          <div 
            className="absolute inset-0 opacity-10"
            style={{
              backgroundColor: '#6B8E3E'
            }}
          />
          
          <div className="container relative z-10">
            <div className="text-center mb-12">
              <p className="text-lg font-semibold mb-2 uppercase" style={{color: 'var(--sereno)'}}
              >
                Nossos eventos
              </p>
              <h2 className="text-4xl md:text-6xl mb-6 font-serif" style={{color: 'var(--aurora)', fontFamily: "'Suez One', serif"}}>
                Exclusividade para nossos clientes
              </h2>
              <p className="max-w-3xl mx-auto" style={{lineHeight: "1.4", color: 'var(--seiva)'}}
              >
                Conecte-se com o futuro da agricultura, participando de eventos exclusivos para nossos 
                clientes e parceiros, onde trazemos informações atualizadas sobre o mercado e as novidades 
                que podem melhorar a performance da sua lavoura.
              </p>
            </div>

            <StaggerContainer className="grid grid-cols-1 md:grid-cols-3 gap-12 max-w-5xl mx-auto">
              <StaggerItem className="h-full">
                  <Card className="glass-card border-0 h-full p-0 rounded-xl cursor-pointer evento-card"
                      style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.15)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '12px'
                      }}>
                  <div className="overflow-hidden" style={{borderTopLeftRadius: '12px', borderTopRightRadius: '12px', height: '305px', margin: 0, padding: 0}}>
                    <img loading="lazy" 
                      src="/images/eventos/safra-financeira.webp" 
                      alt="Safra Financeira"
                      className="w-full h-full object-cover"
                      width="309"
                      height="322"
                      style={{
                        borderTopLeftRadius: '12px', 
                        borderTopRightRadius: '12px',
                        objectPosition: 'top',
                        display: 'block'
                      }}
                    />
                  </div>
                  <CardContent className="pt-2 pb-10 px-6 w-full text-center flex flex-col items-center justify-center">
                    <h3 className="text-lg md:text-2xl font-semibold mb-2 w-full">Safra Financeira</h3>
                    <p className="text-sm md:text-base text-secondary-foreground/80" style={{lineHeight: "1.4"}}>
                      Insights estratégicos sobre mercado e fertilizantes
                    </p>
                  </CardContent>
                </Card>
              </StaggerItem>

              <StaggerItem className="h-full">
                  <Card className="glass-card border-0 h-full p-0 rounded-xl cursor-pointer evento-card"
                      style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.15)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '12px'
                      }}>
                  <div className="overflow-hidden" style={{borderTopLeftRadius: '12px', borderTopRightRadius: '12px', height: '305px', margin: 0, padding: 0}}>
                    <img loading="lazy" 
                      src="/images/eventos/agrobrasilia.webp" 
                      alt="Feira Agrobrasília"
                      className="w-full h-full object-cover"
                      width="458"
                      height="305"
                      style={{
                        borderTopLeftRadius: '12px', 
                        borderTopRightRadius: '12px',
                        objectPosition: 'top',
                        display: 'block'
                      }}
                    />
                  </div>
                  <CardContent className="pt-2 pb-10 px-6 w-full text-center flex flex-col items-center justify-center">
                    <h3 className="text-lg md:text-2xl font-semibold mb-2 w-full">Feira Agrobrasília</h3>
                    <p className="text-sm md:text-base text-secondary-foreground/80" style={{lineHeight: "1.4"}}>
                      Tecnologia e inovação para o agronegócio
                    </p>
                  </CardContent>
                </Card>
              </StaggerItem>

              <StaggerItem className="h-full">
                  <Card className="glass-card border-0 h-full p-0 rounded-xl cursor-pointer evento-card"
                      style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.15)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '12px'
                      }}>
                  <div className="overflow-hidden" style={{borderTopLeftRadius: '12px', borderTopRightRadius: '12px', height: '305px', margin: 0, padding: 0}}>
                    <img loading="lazy" 
                      src="/images/eventos/experiencias-exclusivas.webp" 
                      alt="Experiências Exclusivas"
                      className="w-full h-full object-cover"
                      width="458"
                      height="305"
                      style={{
                        borderTopLeftRadius: '12px', 
                        borderTopRightRadius: '12px',
                        objectPosition: 'right center',
                        display: 'block'
                      }}
                    />
                  </div>
                  <CardContent className="pt-2 pb-10 px-6 w-full text-center flex flex-col items-center justify-center">
                    <h3 className="text-lg md:text-2xl font-semibold mb-2 w-full">Experiências Exclusivas</h3>
                    <p className="text-base text-secondary-foreground/80" style={{lineHeight: "1.4"}}>
                      Networking e conexões estratégicas
                    </p>
                  </CardContent>
                </Card>
              </StaggerItem>
            </StaggerContainer>

            <div className="text-center mt-8">
              <Link href="/nossos-eventos" onClick={scrollToTop}>
                <Button size="lg" variant="secondary" className="bg-accent hover:bg-accent/90 font-semibold uppercase" style={{color: 'var(--sereno)'}}>
                  Conheça nossos eventos
                </Button>
              </Link>
            </div>
          </div>
        </section>

        {/* Cases de Sucesso / Depoimentos */}
        <section className="relative py-12 md:py-16 bg-background flex items-center justify-center" style={{minHeight: '100vh', maxHeight: '100vh'}}>
          {/* Text          {/* Textura lateral direita */}
          <div 
            className="hidden md:block absolute right-0 top-0 h-full"
            style={{
              width: '170px',
              backgroundImage: "url('/images/patterns/pattern-depoimento-transparent.webp')",
              backgroundSize: 'contain',
              backgroundRepeat: 'repeat-y',
              backgroundPosition: 'center'
            }}
          />
          
          {/* Textura com gradiente para mobile */}
          <div 
            className="md:hidden absolute right-0 top-0 h-full"
            style={{
              width: '170px',
              backgroundImage: "url('/images/patterns/pattern-depoimento-transparent.webp')",
              backgroundSize: 'contain',
              backgroundRepeat: 'repeat-y',
              backgroundPosition: 'center',
              maskImage: 'linear-gradient(to bottom, transparent 0%, transparent 10%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,0.5) 40%, rgba(0,0,0,0.9) 50%, rgba(0,0,0,1) 60%, rgba(0,0,0,1) 100%)',
              WebkitMaskImage: 'linear-gradient(to bottom, transparent 0%, transparent 10%, rgba(0,0,0,0.3) 30%, rgba(0,0,0,0.5) 40%, rgba(0,0,0,0.9) 50%, rgba(0,0,0,1) 60%, rgba(0,0,0,1) 100%)'
            }}
          />
          
          <div className="container flex flex-col items-center justify-center h-full relative z-10">
            <div className="text-center mb-8">
              <p className="text-lg font-semibold mb-2 uppercase" style={{color: 'var(--sereno)'}}>Cases de sucesso</p>
              <h2 className="text-4xl md:text-6xl mb-4 text-primary font-serif" style={{fontFamily: "'Suez One', serif"}}>
                Depoimentos
              </h2>
              <p className="max-w-3xl mx-auto mb-8" style={{lineHeight: "1.4", color: 'var(--seiva)'}}
              >
                Conheça os resultados incríveis que nossos clientes alcançaram com as nossas soluções. 
                Através de cases de sucesso, demonstramos a eficácia dos nossos produtos e serviços, 
                inspirando você a alcançar seus objetivos.
              </p>
            </div>
            
            {/* Vídeo vertical centralizado */}
            <div className="w-full max-w-sm mx-auto flex justify-center">
              <div className="aspect-[9/16] rounded-lg overflow-hidden" style={{maxHeight: '60vh', width: 'auto'}}>
                <iframe loading="lazy"
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/G80gh0KsE-4"
                  title="Depoimento de cliente"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Formulário de Orçamento */}
        <section className="relative bg-primary text-primary-foreground overflow-hidden" style={{minHeight: '700px'}}>
          <div className="relative z-10 py-16 md:py-24 h-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 items-stretch h-full">
              {/* Formulário à esquerda */}
              <div className="flex flex-col justify-center container lg:pl-[max(1rem,calc((100vw-1280px)/2))]">
                <FadeInLeft>
                  <h2 className="text-4xl md:text-6xl mb-4 font-serif" style={{fontFamily: "'Suez One', serif"}}>
                    Solicite um orçamento
                  </h2>
                  <p className="mb-8 text-primary-foreground/90" style={{lineHeight: "1.4"}}>
                    Ficou com alguma dúvida ou gostaria de realizar um orçamento personalizado para a sua produção? 
                    Utilize o campo abaixo e nos mande uma mensagem, retornaremos assim que possível para continuar 
                    a nossa comunicação.
                  </p>
                  
                  <form 
                    onSubmit={handleFormSubmit}
                    className="space-y-4"
                  >
                    <input
                      type="text"
                      name="nome"
                      placeholder="Nome"
                      required
                      className="w-full px-4 py-3 rounded-lg bg-white/90 text-primary placeholder:text-primary/60 focus:outline-none focus:ring-2 focus:ring-accent"
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="E-mail"
                      required
                      className="w-full px-4 py-3 rounded-lg bg-white/90 text-primary placeholder:text-primary/60 focus:outline-none focus:ring-2 focus:ring-accent"
                    />
                    <textarea
                      name="mensagem"
                      placeholder="Mensagem"
                      rows={4}
                      required
                      className="w-full px-4 py-3 rounded-lg bg-white/90 text-primary placeholder:text-primary/60 focus:outline-none focus:ring-2 focus:ring-accent"
                    />
                    <button 
                      type="submit" 
                      disabled={formStatus === 'loading'}
                      className="w-full px-6 py-3 bg-accent hover:bg-accent/90 text-primary font-semibold uppercase disabled:opacity-50 disabled:cursor-not-allowed rounded-lg transition-colors"
                    >
                      {formStatus === 'loading' ? 'Enviando...' : 'Enviar'}
                    </button>
                    
                    {formStatus === 'success' && (
                      <div className="p-4 rounded-lg bg-green-500/20 border border-green-500 text-green-100 flex items-center gap-2">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                        </svg>
                        {formMessage}
                      </div>
                    )}
                    
                    {formStatus === 'error' && (
                      <div className="p-4 rounded-lg bg-red-500/20 border border-red-500 text-red-100 flex items-center gap-2">
                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                        </svg>
                        {formMessage}
                      </div>
                    )}
                  </form>
                  
                  <p className="text-sm mt-4 text-primary-foreground/70">
                    Por trabalharmos com vendas diretamente das fábricas para a sua propriedade, existem pedidos mínimos exigidos por cada fornecedor.
                  </p>
                </FadeInLeft>
              </div>
              
              {/* Imagem à direita colada no canto direito da tela */}
              <div className="relative flex items-center justify-end -mx-4 lg:mx-0 mt-8 lg:mt-0">
                <FadeInRight className="w-full lg:w-auto">
                  <img loading="lazy" 
                    src="/images/orcamento-produtor.webp" 
                    alt="Produtor rural Fercci"
                    className="w-full h-auto object-contain lg:max-w-none"
                    style={{maxWidth: '1000px'}}
                  />
                </FadeInRight>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

